'use strict';

const jQuery = require('jquery');

const Container = require('./../../../core/container');
const PasswordValidator = require('password-validator');

const Account = require('./account');
const zone = require('./../../../services/structure/zone');
const Translator = require('./../../../core/translator');
const FormBuilder = require('./../../../services/form');
const Notifier = require('./../../../services/notifier');
const Loader = require('./../../../services/loader');
const Auth = require('./../../../services/auth');
const Help = require('./../../../services/help');

const UserRepo = require('./../repository/UserRepository');

window.PasswordValidator = PasswordValidator;

const onSubmit = function(data, form) {
    Loader.start(Container.get('$smallPanel'));
    UserRepo.getCurrentUser().done(function(user) {
        UserRepo.updatePassword(user.id, data['current_password'], data['new_password'], data['confirm_new_password']).done(function() {
            zone.hidePanels(Container.get('$smallPanel'));
            Notifier.success(Translator.translate('parameters_saved'));

            Auth.logout(true, false);
        }).fail(function() {
            Loader.stop(Container.get('$smallPanel'));
            form.addError('current_password', Translator.translate('error_current_password'));
            form.displayErrors();
        });
    });
};

const onValidate = function(data, form) {
    let schema = new PasswordValidator();

    schema.isMin(8).has().uppercase().has().lowercase().symbols();

    if (data['new_password'] !== data['confirm_new_password']) {
        form.addError('new_password', Translator.translate('error_password_same'));
        form.addError('confirm_new_password', Translator.translate('error_password_same'));
    }

    if (!schema.validate(data['new_password'])) {
        form.addError('new_password', Translator.translate('error_password_format'));
        form.addError('confirm_new_password', Translator.translate('error_password_format'));
    }
};

module.exports.onClick = function() {
    let $layer;
    let form = FormBuilder.getForm({
        'elements': {
            'current_password': {
                'type': 'password',
                'label': Translator.translate('enter_password'),
                'value': '',
            },
            'new_password': {
                'type': 'password',
                'label': Translator.translate('enter_new_password'),
                'value': '',
            },
            'confirm_new_password': {
                'type': 'password',
                'label': Translator.translate('confirm_new_password'),
                'value': '',
            },
        },
        'form': {
            'submit_class': 'd-none',
        },
    });

    Account.close();

    let $container = jQuery('<div></div>');

    $container.append(`<p>${Translator.translate('error_password_format_description')} :</p>`);
    $container.append(`
            <p>
                - ${Translator.translate('error_password_format1')} <br />
                - ${Translator.translate('error_password_format2')} <br />
                - ${Translator.translate('error_password_format3')} <br />
                - ${Translator.translate('error_password_format4')} <br />
            </p>
    `);

    $container.append(form.render());

    $layer = zone.setSmallPanel(Translator.translate('change_password'), $container, {
        'extraTitle': Help.createLink('change_password'),
    });

    form.on('validate', onValidate);
    form.on('submit', onSubmit);

    zone.setFooter($layer, zone.createSubmitButtons({
        onSubmitClick: form.submit.bind(form),
    }));
};
